import { classNames, DisplayTitle, DisplayTitleProps } from '@vkontakte/vkui';
import styles from './CustomDisplayTitle.module.css';

/** HOC DisplayTitle **/
export function CustomDisplayTitle(props: DisplayTitleProps) {
  const { className, ...rest } = props;

  return <DisplayTitle className={classNames(styles.root, className)} {...rest} />;
}
